<template>
 <main-layout>
    <div v-show="!notValid" class="container azSize has-text-centered">
        <div class="is-loading top80">&nbsp;</div>
        <div class="is-size-3 has-text-white isPoppins top40"><b>Just a sec, please...</b></div>
    </div>

    <div v-show="notValid" class="container">
     <div class="is-size-3 has-text-white isPoppins top80"><b>Invalid Request. </b></div>
     <div class="is-size-5 has-text-white isPoppins top20">If you got here by clicking a verification link, please contact support.</div>
    </div>
 </main-layout>
</template>

<script>
import { AZEventBus } from '../components/AZEventBus'
import MainLayout from '../layouts/Main.vue'
export default{
    components: {MainLayout},
    data: function(){
        return {
            inited: false,
            notValid: false
        }
    },

    mounted: function(){

        var self = this;

        function init(){
            
            self.inited = true
            //az.addRemSpinner(true, 'id', 'slinksTable');
            if(self.$route.query.u && self.$route.query.a)
                self.sendAuth()
            
        }

        if(self.$root.doneFederating){
            init();
        }

        AZEventBus.$once('onFederate', msg => {
            if(self.inited == false)
                init();
        });
            
    },

    methods: {
       sendAuth: function() {

        self = this

        function w(d){
          if(d.result == 'FCP'){
            doCog()
          } else {
            this.notValid = true
          }
        }

        function n(){
            this.notValid = true
        }
        //only process if account is in Force Change Password status
        this.$root.apiClient.post('api/account/chkemail', {email: this.$route.query.u}, w, n)

    
        function doCog(){
          self.$root.azCognito.authenticate(
            self.$route.query.u,
            self.$route.query.a,
            authenticateCallBack
          );
        }

        function authenticateCallBack(result, obj) {
          az.addRemSpinner(false, "id", "goButton");
          if (result == "error") {
            self.notValid = true;
            if (
              obj.message == "Incorrect username or password." ||
              obj.message == "User does not exist."
            ) {
              self.errMsg = "Incorrect email or password.";
              self.showErrMsg = true;
            } else if (obj.message == "Password attempts exceeded") {
              self.errMsg =
                "Password attempts limit exceeded, please try again later.";
              self.showErrMsg = true;
            } else if (obj.code == "UserNotConfirmedException") {
              self.$router.push("/unverified");
              self.$root.userAttrs.email = self.email.toLowerCase();
              self.$emit("close");
            }
            return;
          } else if (result == "changePwd") {
            self.$emit("close");
            self.$router.push("/completereg");
            return;
          }

          


          self.$root.doneFederating = false;
        
          // if contidional is true, means email is not verified:
          if (self.$root.doAuthenticated(obj, true)) {
            self.$root.azCognito.logOutUser(null);
          }
        }
      }
    }

}

</script>


// WEBPACK FOOTER //
// src/pages/Activate.vue